import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { fonts } from '@/theme';
import { useModeTokens } from './useModeTokens';

interface LogoMarkProps {
  /** Render the "StudioVault" wordmark next to the glyph. */
  showWordmark?: boolean;
  size?: number;
  /** Pin to one mode instead of following the theme. */
  light?: boolean;
  sx?: SxProps<Theme>;
}

/** The solid-color S glyph plus optional wordmark. */
export const LogoMark: React.FC<LogoMarkProps> = ({
  showWordmark = true,
  size = 26,
  light,
  sx,
}) => {
  const t = useModeTokens(light);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '9px', ...sx }}>
      <Box
        component="span"
        aria-hidden
        sx={{
          width: size,
          height: size,
          flex: 'none',
          borderRadius: `${Math.round(size * 0.31)}px`,
          background: t.gradients.logoMark,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: t.colors.onAccent,
          border: `1px solid ${t.colors.accentFillHover}`,
          boxShadow: t.shadows.button,
          fontFamily: fonts.display,
          fontWeight: 800,
          fontSize: `${Math.round(size * 0.5)}px`,
          lineHeight: 1,
        }}
      >
        S
      </Box>
      {showWordmark && (
        <Box
          component="span"
          sx={{
            fontFamily: fonts.display,
            fontWeight: 700,
            fontSize: '15px',
            letterSpacing: '-0.02em',
            color: t.text.primary,
          }}
        >
          StudioVault
        </Box>
      )}
    </Box>
  );
};

export default LogoMark;
